import { BrowserRouter } from "react-router";
import type { ReactNode } from "react";
import { ProviderComposer, composeProvider } from "@design-lab/shared/lib/ProviderComposer";
import { ConfigProvider, type DesignLabConfig } from "@design-lab/shared/lib/config";
import { ApolloProvider, graphqlClient } from "@design-lab/shared/graphql";

import { ToastProvider } from "@design-lab/shared/ui/toast";
import { NotificationProvider } from "@design-lab/shared/ui/notification";
import { QueryClientProvider } from "./QueryClientProvider";

interface AppProvidersProps {
  children: ReactNode;
  config: DesignLabConfig;
}

export function AppProviders({ children, config }: AppProvidersProps) {
  const providers = [
    QueryClientProvider,
    composeProvider(ApolloProvider, { client: graphqlClient }),
    BrowserRouter,
    composeProvider(ConfigProvider, { config }),
    ToastProvider,
    NotificationProvider
  ];

  return <ProviderComposer providers={providers}>{children}</ProviderComposer>;
}
